import axios from 'axios';

import { DealmaticData } from './types';

export const fetchDeals = (baseUrl: string) => {
  const safeUrl = baseUrl?.substr(-1) === '/' ? baseUrl : `${baseUrl}/`;

  return axios.get<DealmaticData>(`${safeUrl}banners/banners.json`).then(res => res.data?.DealsPage);
};
